import React, { useEffect, useState } from "react";
import { Modal, Steps, Row, Col, Popover } from "antd";
import { Link, useParams } from "react-router-dom";
import { Shipment } from "../components/reverseShipment";
import { Overview } from "../components/overview";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import {
  ReturnBarThunk,
  ReturnDetailThunk,
  ReturnShipmentThunk,
} from "../../../store/thunks/returnThunk";
import {
  resetAcceptReturn,
  resetChangeStatus,
} from "../../../store/slices/returnSlice";

export const ReturnDetails = ({ orderRefId }) => {
  const { data: ReturnDetail } = useSelector((state) => state.returnDetail);
  const { data: bar } = useSelector((state) => state.returnBar);
  const { data: shipment } = useSelector((state) => state.returnShipment);
  const { data: changeStatus } = useSelector(
    (state) => state.changeReturnStatus
  );
  const dispatch = useDispatch();
  const { id } = useParams();
  const { Step } = Steps;
  const customDot = (dot) => <Popover>{dot}</Popover>;
  const [modal1Visible, setModal1Visible] = useState(false);

  useEffect(() => {
    if (id) {
      dispatch(
        ReturnDetailThunk({
          orderRefId: id,
        })
      );
      dispatch(
        ReturnShipmentThunk({
          orderRefId: id,
        })
      );
    }
  }, [id]);

  useEffect(() => {
    if (changeStatus) {
      dispatch(
        ReturnDetailThunk({
          orderRefId: id,
        })
      );
      dispatch(
        ReturnShipmentThunk({
          orderRefId: id,
        })
      );
      dispatch(resetAcceptReturn());
      // dispatch(resetApproveRefund());
      dispatch(resetChangeStatus());
    }
  }, [changeStatus]);

  useEffect(() => {
    dispatch(
      ReturnBarThunk({
        orderRefId: id,
      })
    );
  }, [id]);

  return (
    <>
      <Modal
        title="Detailed Timeline"
        centered
        visible={modal1Visible}
        onOk={() => setModal1Visible(false)}
        onCancel={() => setModal1Visible(false)}
      >
        <Steps
          current={shipment?.orderStatusStream?.length - 1}
          progressDot={customDot}
          className="custom-steps"
          direction="vertical"
        >
          {shipment?.orderStatusStream?.map((status, index) => {
            return <Step title={status} />;
          })}
        </Steps>
      </Modal>

      <div className="content d-flex flex-column flex-column-fluid">
        <div className="container">
          <div className="align-items-center d-flex justify-content-end pb-6">
            <Link
              className="btn btn-primary font-weight-bold letter-spacing btn-md"
              to="/Return"
            >
              View All Return
            </Link>
          </div>
        </div>

        <div className="container">
          <div className="card-body card p-4">
            <Row gutter={[12, 12]} align="middle">
              <Col className="gutter-row" xs={24} lg={12}>
                <h4 className="font-weight-bolder mb-2">
                  Order: #{ReturnDetail?.orderRefId}
                </h4>
                <p className="font-size-lg font-weight-bold mb-2">
                  <span className="font-weight-bolder">Payment Mode:</span>{" "}
                  {ReturnDetail?.paymentMethod}
                </p>
                <p className="font-size-lg font-weight-bold mb-2">
                  <span className="font-weight-bolder">Amount:</span> Rs.{" "}
                  {ReturnDetail?.sellingAmount}
                </p>
                <p className="text-muted font-size-sm mb-2">
                  Last updated at{" "}
                  {moment(ReturnDetail?.lastUpdatedDate).format(
                    "DD/MM/YYYY hh:mm A"
                  )}
                </p>
              </Col>
              <Col className="gutter-row" xs={24} lg={12}>
                <div className="align-items-end d-flex flex-column pb-6">
                  <div className="form-group m-0 my-2 row">
                    <label className="col-form-label font-weight-bolder mr-4">
                      Return Status:
                    </label>
                    <div className="store_option">
                      <span className="btn btn-dark font-weight-bold letter-spacing btn-md cursor-none">
                        {ReturnDetail?.orderStatus}
                      </span>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>

            <div className="mb-5 mt-0 separator separator-solid"></div>

            <div className="main-order-wrapper">
              <Row gutter={[12, 12]}>
                {/**Left Menu Start**/}
                <Col className="gutter-row" xs={24} lg={5}>
                  <div className="border border-1 border-light-dark h-100 rounded-top">
                    <div className="filter-bar bg-gray-700 text-white py-5 px-4 mb-0 h6 font-weight-bolder">
                      Menu
                    </div>
                    <ul className="nav flex-column nav-pills bg-white">
                      <li className="nav-item m-0">
                        <a
                          className="nav-link radius-0 font-weight-bold active"
                          data-toggle="tab"
                          href="#tab_pane_1"
                        >
                          Overview
                        </a>
                      </li>
                      <li className="nav-item m-0">
                        <a
                          className="nav-link radius-0 font-weight-bold"
                          data-toggle="tab"
                          href="#tab_pane_2"
                        >
                          Reverse Shipment
                        </a>
                      </li>
                    </ul>
                  </div>
                </Col>
                {/**Left Menu End**/}

                {/**Tab Panel Start**/}
                <Col className="gutter-row" xs={24} lg={19}>
                  <div className="h-100 border border-0 tab-content">
                    <div
                      className="tab-pane fade active show"
                      id="tab_pane_1"
                      role="tabpanel"
                    >
                      <Overview data={ReturnDetail} />
                    </div>
                    <div
                      className="tab-pane fade"
                      id="tab_pane_2"
                      role="tabpanel"
                    >
                      <Shipment
                        statusBar={bar}
                        data={shipment}
                        orderRefId={id}
                      />
                    </div>
                  </div>
                </Col>
                {/**Tab Panel Start**/}
              </Row>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
